var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoBarPersonalInfoActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_75_1",
    "data-name": "Component 75 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.345,
    height: 25.793,
    viewBox: "0 0 19.345 25.793",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0432a0"
    },
    id: "Path_9060",
    "data-name": "Path 9060",
    d: "M18.634,4.936,14.409.71A2.418,2.418,0,0,0,12.7,0H2.418A2.426,2.426,0,0,0,0,2.423V23.375a2.419,2.419,0,0,0,2.418,2.418h14.51a2.418,2.418,0,0,0,2.418-2.418V6.648a2.43,2.43,0,0,0-.71-1.712ZM12.9,1.642a.793.793,0,0,1,.373.212L17.5,6.079a.793.793,0,0,1,.212.373H12.9Zm.8,22.54H5.642V22.612a1.6,1.6,0,0,1,1.675-1.655,17.972,17.972,0,0,0,2.355.352,18.252,18.252,0,0,0,2.355-.352A1.6,1.6,0,0,1,13.7,22.612Zm4.031-.806a.808.808,0,0,1-.806.806H15.315V22.612a3.373,3.373,0,0,0-.575-1.888,3.236,3.236,0,0,0-2.712-1.379c-.98,0-1.227.352-2.355.352s-1.373-.352-2.355-.352a3.235,3.235,0,0,0-2.712,1.379,3.368,3.368,0,0,0-.575,1.888v1.569H2.418a.808.808,0,0,1-.806-.806V2.423a.812.812,0,0,1,.806-.811h8.868V6.855A1.2,1.2,0,0,0,12.495,8.06h5.238ZM5.642,14.509a4.03,4.03,0,1,0,4.03-4.03A4.03,4.03,0,0,0,5.642,14.509Zm6.448,0A2.418,2.418,0,1,1,9.672,12.09,2.421,2.421,0,0,1,12.09,14.509Z",
    fill: "#484848"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBarPersonalInfoActive);
export default __webpack_public_path__ + "static/media/ico-bar-personalInfo-active.3cc1c0e40a5cd25548dc38c3ff33d96b.svg";
export { ForwardRef as ReactComponent };